import { motion } from 'framer-motion';
import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Container = styled(motion.header)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  padding: 40rem 28rem;
  display: flex;
  gap: 53rem;
  flex-direction: column;

  ${mediaTablet`
    padding: 74rem 32rem;
  `}

  ${mediaDesktop`
    padding: 74rem 92rem;
  `}
`;

export const Wrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled(motion.h1)`
  ${({ theme: { locale } }) => setTypography('navigationLabel', locale)}
  color: ${colors.white};
  white-space: pre-wrap;
  user-select: none;
  display: none;

  ${mediaTablet`
    display: block;
  `}
`;

export const Title = styled(motion.h2)`
  ${({ theme: { locale } }) => setTypography('navigationTitle', locale)}
  color: ${colors.white};
  user-select: none;
  text-align: center;
  text-transform: capitalize;

  &:focus {
    outline: none;
  }
`;

export const BackButtonWrapper = styled(motion.button)`
  z-index: 5;
  display: block;

  svg {
    width: 140rem;
  }

  ${mediaTablet`
    display: none;
  `}
`;
